import { useInfiniteQuery, InfiniteData } from "@tanstack/react-query";
import { siteApi } from "../api/site";

type SitesResponse = {
  rows: any[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    page: number;
    totalPages: number;
    hasMore: boolean;
  };
};

type QueryKey = ["sites", string, number | number[] | string[] | null | undefined, boolean | null];

export const useInfiniteSites = (
  search: string, 
  region?: number | number[] | string[] | null, 
  isThirdParty: boolean | null = false
) => {
  const query = useInfiniteQuery<
    SitesResponse,
    Error,
    InfiniteData<SitesResponse>,
    QueryKey,
    number
  >({
    queryKey: ["sites", search, region, isThirdParty],

    queryFn: async ({ pageParam = 1 }) => {
      const res = await siteApi.getSites({
        page: pageParam,
        limit: 200,
        search,
        region,
        isThirdParty,
      });
      return res.data;
    },

    initialPageParam: 1,

    getNextPageParam: (lastPage) => {
      if (!lastPage?.pagination) {
        return undefined;
      }

      const { page, totalPages } = lastPage.pagination;
      const next = page < totalPages ? page + 1 : undefined;

      return next;
    },

    enabled: true, 
    staleTime: 1000 * 60 * 5, 
    gcTime: 1000 * 60 * 10, 
  });

  const sites = query.data?.pages.flatMap((page) => page.rows) ?? [];

  return {
    ...query,
    sites,
  };
};
